import FuncionalidadesForm from "./FuncionalidadesForm";
export default FuncionalidadesForm;
